import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { CommonService } from "../../Service/CommonService";
import "../Dynamic/UserList.scss";
import { HistoryStepper } from "../Common/HistoryStepper";
import "../Dynamic/MarketValueHistory.scss";
import "../Dynamic/UserList.scss";
import { InventoryApiService } from "../../Service/InventoryApiService";
import { IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const MarketValueHistory = () => {
  const { id, lotId } = useParams<{ id: string; lotId: any }>();
  const [historyData, setHistoryData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    fetchBarrelMarketValueHistory();
  }, [id]);

  const fetchBarrelMarketValueHistory = async () => {
    try {
      setIsLoading(true);
      const response = await InventoryApiService.getBarrelMarketValueHistory(
        id
      );
      setHistoryData(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    history.goBack();
  };

  return (
    <>
      <div className="usersList">
        <div className="usersList__header--wrapper d-flex flex-wrap justify-content-between align-items-center gap-2">
          <div className="d-flex align-items-center">
            {CommonService.isAdmin() && (
              <>
                <IconButton
                  onClick={handleBack}
                  aria-label="ArrowBackIcon"
                  sx={{
                    backgroundColor: "#FFF",
                    "&:hover": { backgroundColor: "#FFF" },
                  }}
                >
                  <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                </IconButton>
              </> 
            )}
            <div className="header--title me-2">
                <h1 className="title mb-0 ms-2">Lot Id : {lotId} Activity</h1>
            </div>
              
          </div>
        </div>
        <div className="user-table-container market-value-history-wrapper">
          <div className="userTable">
            <div className="position-relative pt-4 h-100">
              <HistoryStepper
                historyData={historyData}
                isMarketValueHistory={true}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketValueHistory;
